<template>
  <div class="pdl">
    <el-row v-if="!disabled" type="flex" class="mb10">
      <el-button type="primary" @click="addLine">添加行</el-button>
      <el-button type="primary" @click="clearList">清空</el-button>
    </el-row>
    <el-table border header-cell-class-name="tableHeader" :data="list">
      <el-table-column label="核销单品" prop="auditProductName">
        <template slot-scope="scope">
          <div @click="openModal(scope.row,scope.$index)">
            <el-input placeholder="请选择核销单品" v-model="scope.row.auditProductName" :disabled="disabled"
              readonly></el-input>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="单品年销量/万元" prop="yearSalesNumber">
        <template slot-scope="scope">
          <el-input v-model="scope.row.yearSalesNumber" placeholder="请输入" :disabled="disabled" @change="toFather()"></el-input>
        </template>
      </el-table-column>
      <el-table-column v-if="!disabled" label="操作" width="80px" fixed="right">
        <template slot-scope="scope">
          <span class="delIcon" @click="deleteItem(scope.$index)">删除</span>
        </template>
      </el-table-column>
    </el-table>
    <SelectConfig ref="selectConfig" @onGetSelect="onGetSelect" />
  </div>
</template>
<script>
import request from '@/found/utils/request';
import SelectConfig from '@/found/components/select_org_cus_ter/select_config.vue';

// import NewTreeSelect from './form_tree.vue';

export default {
  props: {
    value: [Array, Object],
    disabled: Boolean,
    fApi: Object,
    getRule: Function,
    setValue: Function,
  },
  components: {
    SelectConfig,
  },
  data() {
    return {
      list: [],
      lineIndex: 0,
    };
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        console.log('// 标记为已执行');
        console.log(value);
        if (value) {
          this.list = value;
        }
      },
    },
  },
  methods: {
    // 新增弹窗
    openModal(row, index) {
      this.lineIndex = index;
      console.log('2222');
      const params = {
        functionCode: 'productList',
        noReset: true,
        paramData: {
          enableStatus: '009',
        },
        pageAble: false,
        data: [{ materialName: this.value ? this.value[this.lineIndex].auditProductName : '', materialCode: this.value ? this.value[this.lineIndex].auditProductCode : '' }],
        selectionList: [],
        idKey: 'materialName',
      };
      this.$refs.selectConfig.openSelectModal(params);
    },
    // 清空
    clearList() {
      this.list = [];
      this.toFather();
    },
    addLine() {
      console.log(1);
      const addList = this.list;
      addList.push({
        yearSalesNumber: '',
        auditProductCode: '',
        auditProductName: '',
      });
      this.list = addList;
      this.toFather();
    },

    onGetSelect(val) {
      console.log('onGetSelect ~ val:', val);
      console.log('lineIndex', this.lineIndex);
      this.list[this.lineIndex].auditProductCode = val[0].materialCode;
      this.list[this.lineIndex].auditProductName = val[0].materialName;
      this.$emit('input', this.list);
    },

    // 暴露数据
    toFather() {
      this.$emit('input', this.list);
    },
    // 行删除
    deleteItem(index) {
      this.list.splice(index, 1);
      this.toFather();
    },
  },
};
</script>
  <style lang="less" scoped>

  /* 关键样式 */
  .clickable-input .el-input__inner {
    pointer-events: none;
    /* 穿透点击事件 */
    cursor: pointer;
    /* 显示手型光标 */
  }

  .pdl {
    //padding-left: 125px;
  }

  /deep/ .tableHeader {
    background-color: #e8e8e8 !important;
  }

  /deep/ .el-tag {
    margin: 4px;
  }

  .mb10 {
    margin-bottom: 10px;
  }

  .delIcon {
    color: #e16063;
    cursor: pointer;
  }

  .addProIcon {
    color: #169bd5;
    cursor: pointer;
    margin: 4px;
  }

  .avatarUploader {
    .el-upload {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }

    .el-upload:hover {
      border-color: #409eff;
    }

    .avatar {
      width: 100px;
      height: 100px;
      display: block;
    }

    .avatarUploaderIcon {
      font-size: 28px;
      color: #8c939d;
      width: 100px;
      height: 100px;
      line-height: 100px;
      text-align: center;
    }
  }

  .cusEtag {
    white-space: break-spaces;
    word-break: break-all;
    height: auto;
    position: relative;
    padding-right: 14px;

    /deep/ .el-icon-close {
      position: absolute;
      right: 1px;
      top: 50%;
      transform: translateY(-50%);
    }
  }

  .tD {
    width: 100%;
    margin-top: 20px;

    .tD_area {
      display: flex;
      align-items: center;
      margin-bottom: 10px;

      .tD_right {
        margin-left: 20px;
        font-size: 14px;
        color: #606266;
        display: flex;
        align-items: center;
      }

      .tD_left {
        font-size: 14px;
        color: #606266;
        width: 275px;

        span {
          color: #de4e52;
          font-size: 14px;
        }
      }

    }
  }
</style>
